var chunkMapping = {
	"283": [
		283
	],
	"388": [
		388
	],
	"391": [
		772
	],
	"436": [
		55
	],
	"511": [
		511
	],
	"601": [
		601
	],
	"676": [
		676
	],
	"683": [
		683
	],
	"971": [
		971
	]
};
var idToExternalAndNameMapping = {
	"55": [
		"default",
		"./Routes",
		544
	],
	"283": [
		"default",
		"./DocumentsRoutes",
		400
	],
	"388": [
		"default",
		"./DailyMemory",
		544
	],
	"511": [
		"default",
		"./MapRoutes",
		400
	],
	"601": [
		"default",
		"./SubjectsRoutes",
		226
	],
	"676": [
		"default",
		"./ChatRoutes",
		226
	],
	"683": [
		"default",
		"./FinanceRoutes",
		400
	],
	"772": [
		"default",
		"./TodoRoutes",
		400
	],
	"971": [
		"default",
		"./AccountsRoutes",
		400
	]
};
var idToRemoteMap = {
	"55": [
		{
			"externalType": "script",
			"name": "imageShare"
		}
	],
	"283": [
		{
			"externalType": "script",
			"name": "homeServices"
		}
	],
	"388": [
		{
			"externalType": "script",
			"name": "imageShare"
		}
	],
	"511": [
		{
			"externalType": "script",
			"name": "homeServices"
		}
	],
	"601": [
		{
			"externalType": "script",
			"name": "homeAgent"
		}
	],
	"676": [
		{
			"externalType": "script",
			"name": "homeAgent"
		}
	],
	"683": [
		{
			"externalType": "script",
			"name": "homeServices"
		}
	],
	"772": [
		{
			"externalType": "script",
			"name": "homeServices"
		}
	],
	"971": [
		{
			"externalType": "script",
			"name": "homeServices"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"55": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 544,
		"remoteName": "imageShare"
	},
	"283": {
		"shareScope": "default",
		"name": "./DocumentsRoutes",
		"externalModuleId": 400,
		"remoteName": "homeServices"
	},
	"388": {
		"shareScope": "default",
		"name": "./DailyMemory",
		"externalModuleId": 544,
		"remoteName": "imageShare"
	},
	"511": {
		"shareScope": "default",
		"name": "./MapRoutes",
		"externalModuleId": 400,
		"remoteName": "homeServices"
	},
	"601": {
		"shareScope": "default",
		"name": "./SubjectsRoutes",
		"externalModuleId": 226,
		"remoteName": "homeAgent"
	},
	"676": {
		"shareScope": "default",
		"name": "./ChatRoutes",
		"externalModuleId": 226,
		"remoteName": "homeAgent"
	},
	"683": {
		"shareScope": "default",
		"name": "./FinanceRoutes",
		"externalModuleId": 400,
		"remoteName": "homeServices"
	},
	"772": {
		"shareScope": "default",
		"name": "./TodoRoutes",
		"externalModuleId": 400,
		"remoteName": "homeServices"
	},
	"971": {
		"shareScope": "default",
		"name": "./AccountsRoutes",
		"externalModuleId": 400,
		"remoteName": "homeServices"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}